import React, { useState, useEffect } from "react";
import { useWatchState } from "@/store";
import { checkResult, second2Date } from "@/common";
import { BaseService } from "@/service";
import { demandType } from "@/dic";
import { Modal, Tag, Icon } from "antd";

const NAME = "demandDetail";

const App = () => {

    const [[modalProps]] = useWatchState(["modal." + NAME])
    const { title = "需求详情", show, hide, width = 800, demandId } = modalProps;

    const [data, setData] = useState({ scopes: [], type: "" });

    useEffect(() => {
        if (demandId) getDetail(demandId)
    }, [demandId])

    const getDetail = xuqiu_id => {
        BaseService.list({
            table: "thtt_xuqiu",
            where: { xuqiu_id },
            leftJoin: {
                table: "thtt_organization",
                on: "thtt_organization.organization_id = thtt_xuqiu.unit",
                columns: ["profile AS orgProfile"]
            },
            process: {
                name: "scopes",
                key: "xuqiu_id",
                targetKey: "xuqiu_id",
                params: {
                    table: "thtt_xuqiu_scope",
                    leftJoin: {
                        table: "thtt_scope",
                        on: "thtt_xuqiu_scope.second_scope_id = thtt_scope.id",
                        columns: ["name AS scopeName"]
                    }
                }
            }
        }).then(res => {
            if (!checkResult(res)) return;
            setData(res.data.result[0]);
        })
    }

    return (
        <Modal
            title={title}
            visible={show}
            width={width}
            maskClosable={false}
            onCancel={hide}
            footer={false}
            destroyOnClose={true}
        >
            <h3 className="m-xs-b bold-800">{data.name}</h3>
            <div>
                <p className="child-left-sm flex ver font-size-14">
                    <Icon type="clock-circle" />
                    <span>{second2Date(data.add_time)}</span>
                </p>
            </div>

            <h4 className="m-md-t bold-800">需求简介</h4>
            <div className="page-demandDetail__html m-sm-t" dangerouslySetInnerHTML={{ __html: data.profile }} />

            <h4 className="m-md-t bold-800">需求领域</h4>
            <div className="m-sm-t">
                {data.scopes.map(({ scopeName }) => <Tag color="blue">{scopeName}</Tag>)}
            </div>

            <h4 className="m-md-t bold-800">需求类型</h4>
            <div className="page-demandDetail__dark-bg m-sm-t">{data.type ? data.type.split(",").filter(v => v).map(v => demandType[v] && demandType[v].label).join("、") : "-"}</div>

            <h4 className="m-md-t bold-800">机构简介</h4>
            <div className="page-demandDetail__html m-sm-t" dangerouslySetInnerHTML={{ __html: data.orgProfile }} />
        </Modal>
    );
}

export default App;